export default __webpack_public_path__ + "static/media/add user.d02c8f80.svg";